(function(global) {
  'use strict';

  function getZoomForCapacity(capacity) {
    if (!isFinite(capacity) || capacity < 1.3) return 0;
    return Math.min(capacity, 3);
  }

  function getImageQuality(img, masterWidth, masterHeight) {
    if (!img) return { enabled: false, capacity: 0, zoom: 0 };

    var rect = img.getBoundingClientRect();
    var width = rect.width || img.offsetWidth || 0;
    var height = rect.height || img.offsetHeight || 0;
    var sourceWidth = Number(masterWidth || img.dataset.masterWidth);
    var sourceHeight = Number(masterHeight || img.dataset.masterHeight);

    if (!width || !height || !sourceWidth || !sourceHeight) {
      return { enabled: false, capacity: 0, zoom: 0 };
    }

    var widthCapacity = sourceWidth / width;
    var heightCapacity = sourceHeight / height;
    var capacity = Math.min(widthCapacity, heightCapacity);
    var zoom = getZoomForCapacity(capacity);

    return {
      enabled: zoom > 1,
      capacity: capacity,
      zoom: zoom
    };
  }

  global.PDPZoomQuality = {
    getImageQuality: getImageQuality,
    getZoomForCapacity: getZoomForCapacity
  };
})(window);
